import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import classNames from 'classnames';
import type CustomField from '@/types/api/CustomField';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import EditCustomField from './EditCustomField';

function CustomFieldsDraggable({
  field,
  isExpanded,
  onExpand,
}: {
  field: CustomField;
  isExpanded: boolean;
  onExpand: (fieldId: string) => void;
}) {
  const { attributes, listeners, setNodeRef, transform } = useSortable({
    id: field.customFieldId,
  });
  const style = React.useMemo(
    () =>
      transform
        ? {
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
          }
        : undefined,
    [transform],
  );

  return (
    <>
      <div
        className={classNames('flex justify-between p-4 hover:cursor-default', {
          'hover:bg-grey-100': !isExpanded,
        })}
        ref={setNodeRef}
        style={style}
        {...attributes}
      >
        <div className="flex">
          <DensitySmallIcon className="hover:cursor-pointer" {...listeners} />
          <div className="ml-5">{field.fieldName}</div>
        </div>
        {isExpanded ? (
          <ExpandLess
            onClick={() => {
              onExpand('');
            }}
          />
        ) : (
          <ExpandMore
            onClick={() => {
              onExpand(field.customFieldId);
            }}
          />
        )}
      </div>
      {isExpanded && (
        <EditCustomField field={field} setExpandedItem={onExpand} />
      )}
    </>
  );
}

export default CustomFieldsDraggable;
